/* eslint-disable */
import { useEffect, useRef } from "react";

import LoadingSpinner from "./loading-spinner";
import "./common.css";

export default function LoadingModal({ open = false, text = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (open) {
      ref.current?.showModal();
      document.body.classList.add("modal-open"); // prevent bg scroll
    } else {
      ref.current?.close();
      document.body.classList.remove("modal-open");
    }
  }, [open]);

  return (
    <dialog className="loading-modal-dialog" open={open}>
      <LoadingSpinner />
      <div className="loading-modal-container">
        <p className="loading-modal-text loading-modal">{text}</p>
        <p className="loading-modal-text modal-text-bottom">
          Esto puede tardar, por favor espere.
        </p>
        <p className="loading-modal-text modal-text-bottom">
          No recargue la página ni cierre esta ventana.
        </p>
      </div>
    </dialog>
  );
}
